var Chart = require('chart.js');

export default class Charts {
	constructor(el) {
		this.charts = document.querySelectorAll('canvas.chart');

	}

	reveal() {
		for (var c = 0; c < this.charts.length; c++) {
			var c1 = this.charts[c];
			var legend = c1.nextElementSibling;
			var th = legend.querySelectorAll('th');
			var labels = [], values = [], colours = [];
			for (var i = 0; i < th.length; i++) {
				labels.push(th[i].innerHTML);
			}
			var td = legend.querySelectorAll('td');
			for (var i = 0; i < td.length; i++) {
				// Required for wrapper td:
				if (td[i].hasAttribute('style')) {
					values.push(parseInt(td[i].innerHTML.replace(',','')));
					colours.push(td[i].style.color);
				}
			}
			var newChart = new Chart(c1, {
				type: 'doughnut',
				data: {
					labels: labels,
					datasets: [{
						data: values,
						backgroundColor: colours,
						borderWidth: 0,
					}],
				},
				options: {
  				animation: {
    				duration: 1800,
  				},
					aspectRatio : 1,
					legend: {
						display: false,
					},
					tooltips: {
						enabled: false,
					}
				}
			});
		}
	}
}
